// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3sgOa","right":"styles_right__39uM_"};